var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.1099H21V10.0684H12V14.0684H17.6515C16.827 16.3969 14.6115 18.0684 12 18.0684C8.6865 18.0684 6 15.3819 6 12.0684C6 8.75486 8.6865 6.06836 12 6.06836C13.5295 6.06836 14.921 6.64536 15.9805 7.58786L18.809 4.75936C17.023 3.09486 14.634 2.06836 12 2.06836C6.4775 2.06836 2 6.54586 2 12.0684C2 17.5909 6.4775 22.0684 12 22.0684C17.5225 22.0684 22 17.5909 22 12.0684C22 11.3979 21.931 10.7434 21.8055 10.1099Z",
    fill: "#FBC02D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15332 7.41386L6.43882 9.82336C7.32782 7.62236 9.48082 6.06836 12.0003 6.06836C13.5298 6.06836 14.9213 6.64536 15.9808 7.58786L18.8093 4.75936C17.0233 3.09486 14.6343 2.06836 12.0003 2.06836C8.15932 2.06836 4.82832 4.23686 3.15332 7.41386Z",
    fill: "#E53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 22.0687C14.5832 22.0687 16.9302 21.0802 18.7047 19.4727L15.6097 16.8537C14.6057 17.6142 13.3577 18.0687 12.0002 18.0687C9.39916 18.0687 7.19066 16.4102 6.35866 14.0957L3.09766 16.6082C4.75266 19.8467 8.11366 22.0687 12.0002 22.0687Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.1099L21.7975 10.0684H21H12V14.0684H17.6515C17.2555 15.1869 16.536 16.1514 15.608 16.8539L15.6095 16.8529L18.7045 19.4719C18.4855 19.6709 22 17.0684 22 12.0684C22 11.3979 21.931 10.7434 21.8055 10.1099Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.75288e34.svg";
export { ForwardRef as ReactComponent };